import { render, staticRenderFns } from "./MiniRelativeDateRange.vue?vue&type=template&id=2ba92cba&scoped=true&"
import script from "./MiniRelativeDateRange.vue?vue&type=script&lang=js&"
export * from "./MiniRelativeDateRange.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ba92cba",
  null
  
)

export default component.exports